import { BaseAPI } from 'grow-fe-base-api/dist/grow-fe-base-api';

/**
 * @typedef {ResponseEnvelope}
 *
 * Response from api
 *
 * @prop {Boolean} success if suceesful
 * @prop {*} data data you need
 *
 */
class API extends BaseAPI {
  constructor(options) {
    const settings = Object.assign({}, options, {
      apiRoot: process.env.VUE_APP_API_PATH,
    });

    super(settings);

    this.removeDefaultUpdateHeader('Content-Type');

    if (process.env.VUE_APP_AUTH) {
      this.addDefaultHeader('Authorization', process.env.VUE_APP_AUTH);
      this.addDefaultUpdateHeader('Authorization', process.env.VUE_APP_AUTH);
    }
  }

  getExampleCallback(callback) {
    this.get('example-path', {}, callback);
  }

  /**
   * Dev method
   *
   * @returns
   * @memberof API
   */
  ping() {
    return this.get({
      url: 'ping',
    }).promise;
  }

  /**
   * Dev method
   *
   * @param {*} payload
   * @returns
   * @memberof API
   */
  echo(payload) {
    return this.post({
      url: 'echo',
      headers: {
        'Content-Type': 'application/json'
      },
      payload,
    }).promise;
  }

  /**
   * Make a submission to api
   *
   * @param {*} user user from RB Login api
   * @param {FormData} payload
   * @param {Function} progress progress callback
   * @returns {API~Call}
   * @memberof API
   */
  makeSubmission(payload, progress) {
    return this.post({
      url: 'submission/new',
      // headers: {
      //   'Authorization': `Bearer: ${token}`, // eslint-disable-line
      // },
      payload,
      progress,
    });
  }

  /**
   * Get a submission if its already been made
   *
   * @returns {API~Call}
   * @memberof API
   */
  getUserSubmission(userToken) {
    return this.post({
      url: 'user',
      headers: {
        'Content-Type': 'application/json'
      },
      payload: userToken
    });
  }

  /**
   * Get a submission with the id "id"
   *
   * @param {*} submissionId
   * @returns {API~Call}
   * @memberof API
   */
  getSubmission(submissionId) {
    return this.get({
      url: `submission/id/${submissionId}`,
    });
  }

  /**
   * Get submissions from API
   *
   * @param {*} page
   * @param {*} perPage
   * @returns {API~Call}
   * @memberof API
   */
  getSubmissions(page, perPage) {
    const url = `submissions?page=${page || 1}&perPage=${perPage}`;

    return this.get({
      url
    });
  }

  /**
   * Report submission
   *
   * @param {String} submissionId
   * @returns {API~Call}
   * @memberof API
   */
  reportSubmission(submissionId) {
    return this.post({
      url: `submission/report/${submissionId}`,
    });
  }
}

export default new API();
